export const en = {
    newAudience: 'New audience',
    newGroup: 'New group'
};
